import React, { useState } from "react";

interface StarRatingProps {
  fieldKey: string;
  rating: number;
  onChange: (fieldKey: string, value: number) => void;
}

const StarRating: React.FC<StarRatingProps> = ({
  fieldKey,
  rating,
  onChange,
}) => {
  const [hover, setHover] = useState<number>(0);

  const UnfilledStar = "/icons/star_unfilled.svg";
  const FilledStar = "/icons/star_filled.svg";

  const handleClick = (value: number) => {
    onChange(fieldKey, value);
  };

  const handleMouseOver = (value: number) => {
    setHover(value);
  };

  const handleMouseLeave = () => {
    setHover(0);
  };

  const getStarIcon = (value: number) => {
    if (value <= (hover || rating)) {
      return (
        <img
          style={{ marginRight: "8px", cursor: "pointer" }}
          src={FilledStar}
          alt="filled star"
        />
      );
    }
    return (
      <img
        style={{ marginRight: "8px", cursor: "pointer" }}
        src={UnfilledStar}
        alt="unfilled star"
      />
    );
  };

  return (
    <div style={{ marginBottom: "12px" }}>
      {Array.from({ length: 5 }, (_, index) => index + 1).map((value) => (
        <span
          key={value}
          onClick={() => handleClick(value)}
          onMouseOver={() => handleMouseOver(value)}
          onMouseLeave={handleMouseLeave}
        >
          {getStarIcon(value)}
        </span>
      ))}
    </div>
  );
};

export default StarRating;
